var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-col',{staticClass:"py-0"},[_c('v-input',{directives:[{name:"show",rawName:"v-show",value:(false),expression:"false"}],attrs:{"hide-details":true,"value":_vm.value,"rules":_vm.rules}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }